// extracted by mini-css-extract-plugin
export const wrapper = "property-map-module--wrapper--2HA-T";
export const pin = "property-map-module--pin--CBwas";